import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/error.tsx");
